interface NavigationProps {
  isScrolled: boolean;
}

export default function Navigation({ isScrolled }: NavigationProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-8 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://public.readdy.ai/ai/img_res/f95e5c5f-05b7-4e76-8a6c-73efb4cf97b3.png" 
              alt="POLONYI S.R.L. Logo" 
              className="h-10 w-10 object-contain"
            />
            <span className={`text-xl font-semibold transition-colors ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
              POLONYI S.R.L.
            </span>
          </div>

          <div className="flex items-center gap-12">
            <button
              onClick={() => scrollToSection('home')}
              className={`text-sm font-light transition-colors hover:opacity-80 whitespace-nowrap ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('features')}
              className={`text-sm font-light transition-colors hover:opacity-80 whitespace-nowrap ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`text-sm font-light transition-colors hover:opacity-80 whitespace-nowrap ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('support')}
              className={`text-sm font-light transition-colors hover:opacity-80 whitespace-nowrap ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              Support
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-light transition-colors hover:opacity-80 whitespace-nowrap ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              Contact
            </button>
          </div>

          <button
            onClick={() => scrollToSection('contact')}
            className="px-6 py-2.5 bg-[#B8E986] text-gray-900 rounded-full text-sm font-medium hover:bg-[#A5D675] transition-colors whitespace-nowrap"
          >
            Get Started
          </button>
        </div>
      </div>
    </nav>
  );
}
